/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    { if: { error: true }, tokens: { inputBorderColor: '#e12339' } },
    {
      if: { focus: true },
      tokens: { inputBorderColor: '#7c53a5', inputBorderWidth: 3 }
    },
    {
      if: { inactive: true },
      tokens: {
        descriptionFontColor: '#676e73',
        iconBackgroundColor: '#e3e6e8',
        iconColor: '#676e73',
        inputBackgroundColor: '#e3e6e8',
        inputBorderColor: 'rgba(0, 0, 0, 0)',
        labelColor: '#676e73'
      }
    },
    {
      if: { hover: true },
      tokens: { inputOutlineColor: '#e3e6e8', inputOutlineWidth: 2 }
    },
    {
      if: { checked: true, focus: true },
      tokens: {
        inputBorderColor: '#ffffff',
        inputBorderWidth: 2,
        inputOutlineColor: '#7c53a5',
        inputOutlineWidth: 3
      }
    }
  ],
  tokens: {
    containerBackgroundColor: 'rgba(0, 0, 0, 0)',
    descriptionFontColor: '#414547',
    descriptionFontName: 'HNforTELUSSA',
    descriptionFontSize: 14,
    descriptionFontWeight: '400',
    descriptionLineHeight: 1.42857142857,
    descriptionMarginLeft: null,
    feedbackMarginBottom: 0,
    feedbackMarginTop: 2,
    feedbackPosition: 'bottom',
    icon: PaletteIconCheckbold,
    iconBackgroundColor: '#7c53a5',
    iconColor: '#ffffff',
    iconSize: 16,
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#676e73',
    inputBorderRadius: 4,
    inputBorderWidth: 1,
    inputHeight: 20,
    inputOutlineColor: null,
    inputOutlineOffset: 0,
    inputOutlineWidth: 0,
    inputShadow: null,
    inputWidth: 20,
    labelColor: '#414547',
    labelFontName: 'HNforTELUSSA',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    labelMarginLeft: 8
  }
}
export default theme
